import { useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import ExclusionDrawer from "./ExclusionDrawer/ExclusionDrawer";
import PartnerFeeDrawer from "./PartnerFeeDrawer/PartnerFeeDrawer";

const tableHeaders = [
  { text: "Product", value: "Users.fullName" },
  { text: "Sub product (IP/OP)", value: "Users.city" },
  { text: "Region", value: "Orders.price" },
  { text: "Term 01 ($/%)", value: "Orders.status" },
  { text: "Figure", value: "Orders.createdAt" },
  { text: "Treatment slab", value: "Orders.createdAt" },
  { text: "Treatment", value: "Orders.createdAt" },
  { text: "Sub Region slab", value: "Orders.createdAt" },
  { text: "Sub Region", value: "Orders.createdAt" },
  { text: "Revenue Slab", value: "Orders.createdAt" },
  { text: "From", value: "Orders.createdAt" },
  { text: "To", value: "Orders.createdAt" },
  { text: "RMP", value: "Orders.createdAt" },
  { text: "Common Exclusions", value: "Orders.createdAt" },
  { text: "Partner Fee", value: "Orders.createdAt" },
];

const tableHeadersDr = [
  { text: "Product", value: "Users.fullName" },
  { text: "Sub product (IP/OP)", value: "Users.city" },
  { text: "Term ($/%)", value: "Orders.price" },
  { text: "Figure", value: "Orders.status" },
  { text: "Treatment slab", value: "Orders.createdAt" },
  { text: "Treatment", value: "Orders.createdAt" },
  { text: "Treatment Grade Slab", value: "Orders.createdAt" },
  { text: "Treatment Grade", value: "Orders.createdAt" },
];

function AgreementTable({ showTable, tableDataa }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isPartnerFeeOpen, setIsPartnerFeeOpen] = useState(false);
  const [drawerData, setDrawerData] = useState([]);

  return (
    <TableContainer
      component={Paper}
      sx={{
        backgroundColor: "#F9FBFC",
        maxHeight: "54vh",
        borderRadius: "10px",
        boxShadow: "rgba(149, 157, 165, 0.1) 0px 2px 14px;",
        "&::-webkit-scrollbar": {
          width: "5px",
          backgroundColor: "#F5F5F5",
        },
        "&::-webkit-scrollbar-thumb": {
          borderRadius: "4px",
          backgroundColor: "#17dfba86",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "#17dfba",
        },
      }}>
      <ExclusionDrawer
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        drawerData={drawerData}
      />
      <PartnerFeeDrawer
        setIsOpen={setIsPartnerFeeOpen}
        isOpen={isPartnerFeeOpen}
        drawerData={drawerData}
      />

      {showTable && (
        <Table
          style={{
            backgroundColor: "white",
            width: "164%",
          }}
          aria-label="table">
          <TableHead
            sx={{
              position: "sticky",
              bgcolor: "white",
              top: 0,
              zIndex: 999,
              border: "none",
            }}>
            {tableDataa?.
              professionalAgreementDataResponses ? (
              <TableRow>
                {tableHeadersDr.map((item) => (
                  <TableCell
                    style={{ fontSize: "14px" }}
                    sx={{
                      color: "#4C5A6A",
                      borderRight: 1,
                      borderColor: "#E0E0E0",
                    }}
                    key={item.value + Math.random()}>
                    <span style={{ fontSize: "14px", fontWeight: 500 }}>
                      {item.text}
                    </span>
                  </TableCell>
                ))}
              </TableRow>
            ) : (
              <TableRow>
                {tableHeaders.map((item) => (
                  <TableCell
                    style={{ fontSize: "14px" }}
                    sx={{
                      // color: "#4C5A6A",
                      borderRight: 1,
                      borderColor: "#E0E0E0",
                    }}
                    key={item.value + Math.random()}>
                    <span style={{ fontSize: "14px", fontWeight: 500 }}>
                      {item.text}
                    </span>
                  </TableCell>
                ))}
              </TableRow>
            )}
          </TableHead>
          {tableDataa?.
            professionalAgreementDataResponses ? (
            <TableBody>
              {tableDataa.
                professionalAgreementDataResponses?.map((data) => (
                  <TableRow>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data?.product}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data?.subProduct}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data?.term}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data?.figure}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data?.treatmentSlab ? "True" : "False"}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data?.treatmentName}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data?.treatmentGradeSlab}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data?.treatmentGrade}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          ) : (
            <TableBody>
              {tableDataa.centerAgreementDataList
                ?.map((data) => (
                  <TableRow>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data.product}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data.subProduct}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data.region}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data.term}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data.figure}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data.treatmentSlab ? "True" : "False"}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data.treatmentName}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data.subRegionSlab}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data.subRegionName}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data.revenueSlab}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data.revenueSlabFrom}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data.revenueSlabTo}
                    </TableCell>
                    <TableCell
                      sx={{
                        borderRight: 1,
                        borderColor: "rgba(224, 224, 224, 1)",
                      }}>
                      {data.rmp}
                    </TableCell>
                    <TableCell
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setDrawerData(data);
                        setIsOpen((c) => !c);
                      }}>
                      {"More Details"}
                    </TableCell>
                    <TableCell
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setDrawerData(data);
                        setIsPartnerFeeOpen((c) => !c);
                      }}>
                      {"More Details"}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          )}
        </Table>
      )}
    </TableContainer>
  );
}

export default AgreementTable;
